import { buildInfoWindowContent } from './infoWindowContent';
import { validPoint, formatAccuracy } from './fieldOperation';

// #Fase2-B5 — Usa el mismo DOM seguro del mapa cliente; nunca interpola HTML remoto.
export function evidencePins(points = []) {
  return points.filter(validPoint).map((point, index) => ({ ...point, pinId: `${point.question_id}-${index}` }));
}

export function evidenceContent(point) {
  const time = point.captured_at ? new Date(point.captured_at).toLocaleString('es-MX') : 'Sin hora';
  const precision = formatAccuracy(point.accuracy_m);
  const root = buildInfoWindowContent({
    title: [point.code, point.title].filter(Boolean).join(' — '),
    label: point.answer_label || 'Sin respuesta',
    notes: [point.zone?.label, point.zone?.detail, time, precision].filter(Boolean).join(' · '),
  });
  // #Fase2-B5 — Solo imágenes HTTP(S); bloquea esquemas activos aunque vengan de la API.
  if (typeof point.thumb_url === 'string' && /^https?:\/\//i.test(point.thumb_url)) {
    const image = document.createElement('img');
    image.src = point.thumb_url;
    image.alt = 'Evidencia';
    image.style.cssText = 'display:block;max-width:200px;max-height:140px;margin-top:8px';
    root.append(image);
  }
  return root;
}

export function mountEvidencePins(map, points, maps = window.google.maps) {
  const objects = [];
  evidencePins(points).forEach((point) => {
    const position = { lat: point.lat, lng: point.lng };
    const marker = new maps.Marker({ map, position, title: point.title, label: 'E' });
    // #Fase2-B5 — Asignar src ya descarga la foto, incluso con el nodo fuera del DOM.
    const info = new maps.InfoWindow();
    const listener = marker.addListener('click', () => {
      info.setContent(evidenceContent(point));
      info.open(map, marker);
    });
    objects.push(() => {
      listener.remove();
      info.close();
      marker.setMap(null);
    });
    if (Number.isFinite(point.accuracy_m) && point.accuracy_m >= 0) {
      const circle = new maps.Circle({
        map, center: position, radius: point.accuracy_m,
        strokeColor: '#2563eb', strokeOpacity: 0.4, fillColor: '#2563eb', fillOpacity: 0.08,
        clickable: false,
      });
      objects.push(() => circle.setMap(null));
    }
  });
  return () => objects.forEach((remove) => remove());
}
